<template>
  <LayoutPrincipal>
    <div class="dashboard">
      <!-- KPIs -->
      <div class="grid-kpis">
        <div class="kpi-card">
          <h2>Prueba uno</h2>
          <p>1,254</p>
          <div class="mini-bar" :style="{ '--value': '70%' }"></div>
        </div>
        <div class="kpi-card">
          <h2>Prueba dos</h2>
          <p>$2,435,000</p>
          <div class="mini-bar" :style="{ '--value': '90%' }"></div>
        </div>
        <div class="kpi-card">
          <h2>Prueba tres</h2>
          <p>15 de junio</p>
          <div class="mini-bar" :style="{ '--value': '50%' }"></div>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Prueba cuatro</h2>
          <p>856</p>
          <div class="mini-bar" :style="{ '--value': '60%' }"></div>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Prueba cinco</h2>
          <p>420</p>
          <div class="mini-bar" :style="{ '--value': '30%' }"></div>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Prueba seis</h2>
          <p>378</p>
          <div class="mini-bar" :style="{ '--value': '25%' }"></div>
        </div>
        <!-- <div class="kpi-card kpi-deuda">
          <h2>Deuda Nómina Actual</h2>
          <p>$1,150,000</p>
          <div class="mini-bar" :style="{ '--value': '55%' }"></div>
        </div>
        <div class="kpi-card kpi-pagado">
          <h2>Pagos Realizados Año</h2>
          <p>$8,230,000</p>
          <div class="mini-bar" :style="{ '--value': '85%' }"></div>
        </div> -->
      </div>

      <!-- Gráficas principales -->
      <div class="graficas">
        <div class="grafica">
          <h2>Prueba</h2>
          <BarChart :data="barChartData" />
        </div>
        <div class="grafica">
          <h2>Prueba</h2>
          <PieChart :data="pieChartData" />
        </div>
      </div>

      <!-- Gráficas pequeñas -->
      <div class="graficas-mini">
        <div class="grafica-mini">
          <h3>Prueba</h3>
          <PieChart :data="ciudadesChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Prueba</h3>
          <PieChart :data="edadChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Prueba</h3>
          <PieChart :data="contratoChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Prueba</h3>
          <PieChart :data="ejemploChartData" />
        </div>
      </div>
    </div>
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import BarChart from "../layouts/BarChart.vue";
import PieChart from "../layouts/PieChart.vue";

export default {
  components: {
    LayoutPrincipal,
    BarChart,
    PieChart
  },
  data() {
    return {
      barChartData: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        datasets: [
          {
            label: "Monto Pagado",
            backgroundColor: "#6E44DA", // Guinda 4T
            data: [1200000, 1500000, 1000000, 1800000, 1600000, 2000000],
          },
        ],
      },
      pieChartData: {
        labels: ["Préstamos", "Aguinaldos", "Vacaciones"],
        datasets: [
          {
            backgroundColor: ["#6E44DA", "#888888", "#cccccc"], // guinda + grises
            data: [45, 30, 25],
          },
        ],
      },
      ciudadesChartData: {
        labels: ["Culiacán", "Mazatlán", "Los Mochis", "Guasave"],
        datasets: [
          {
            backgroundColor: ["#6E44DA", "#999999", "#bbbbbb", "#dddddd"], // guinda + varios grises
            data: [120, 90, 60, 30],
          },
        ],
      },
      edadChartData: {
        labels: ["<30", "30-40", "40-50", "50+"],
        datasets: [
          {
            backgroundColor: ["#6E44DA", "#7f7f7f", "#b0b0b0", "#d0d0d0"], // guinda + tonos de gris medio a claro
            data: [50, 150, 200, 100],
          },
        ],
      },
      contratoChartData: {
        labels: ["Base", "Temporal", "Honorarios"],
        datasets: [
          {
            backgroundColor: ["#6E44DA", "#666666", "#999999"], // guinda + grises medianos
            data: [300, 120, 60],
          },
        ],
      },
      ejemploChartData: {
        labels: ["Ejemplo", "Hola", "Que tal", "Otro"],
        datasets: [
          {
            backgroundColor: ["#6E44DA", "#d0d0d0", "#666666", "#999999"], // guinda + grises medianos
            data: [125, 60, 90, 60],
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.dashboard {
  font-family: Arial, sans-serif;
  color: #333;
}

/* KPIs */
.grid-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 18px;
  margin-bottom: 20px;
}

.kpi-card {
  background-color: #f5f8fa;
  border-radius: 14px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: default;
  user-select: none;
  position: relative;
  color: #2c3e50;
}

.kpi-card .mini-bar::after {
background: #6E44DA;
  /* Barra azul oscuro */
}

.kpi-card:hover {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}

.kpi-card h2 {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0 0 10px 0;
  min-height: 38px;
  line-height: 1.2;
  font-weight: 600;
  text-align: center;
}

.kpi-card p {
  font-size: 26px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  text-align: center;
}

/* Mini gráfica barra debajo del valor */
.mini-bar {
  --bar-height: 6px;
  width: 100%;
  height: var(--bar-height);
  background-color: #d1d8de;
  border-radius: 4px;
  margin-top: 12px;
  position: relative;
  overflow: hidden;
}

.mini-bar::after {
  content: "";
  display: block;
  height: var(--bar-height);
  width: var(--value);
  background-color: #6E44DA;
  /* Guinda 4T */
  border-radius: 4px;
  transition: width 0.5s ease;
}

/* Para kpi-special */
.kpi-special {
  background-color: #f5f8fa;
  color: #1b4f72;
  /* azul más vivo */
  font-weight: 700;
}

.kpi-special .mini-bar::after {
  background:  #6E44DA;
  /* barra con degradado azul */
}

/* Para deuda (color rojo) */
.kpi-deuda {
  background-color: #fdecea;
  color: #c0392b;
  /* rojo más fuerte */
  font-weight: 700;
}

.kpi-deuda .mini-bar::after {
  background: linear-gradient(90deg, #96190c, #e74c3c);
  /* barra degradada roja */
}

/* Para pagado (color verde) */
.kpi-pagado {
  background-color: #e8f5e9;
  color: #27ae60;
  /* verde vivo */
  font-weight: 700;
}

.kpi-pagado .mini-bar::after {
  background: linear-gradient(90deg, #13743b, #2ecc71);
  /* barra degradada verde */
}

/* Gráficas principales */
.graficas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.grafica {
  box-shadow: 0px 3px 6px #00000029;
  background-color: white;
  padding: 30px 25px;
  border-radius: 16px;
  max-height: 375px;
  /* Para limitar la altura */
  overflow: hidden;
}

.grafica h2 {
  margin-top: 0px;
  margin-bottom: 14px;
  font-weight: 700;
  color: #34495e;
}

/* Gráficas pequeñas */
.graficas-mini {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.grafica-mini {
  box-shadow: 0px 3px 6px #00000029;
  background-color: white;
  padding: 20px 18px;
  border-radius: 14px;
  max-height: 300px;
  /* Limita la altura para evitar scroll */
  overflow: hidden;
}

.grafica-mini h3 {
  margin-top: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  text-align: center;
}

/* Responsive */
@media (max-width: 900px) {
  .graficas {
    grid-template-columns: 1fr;
  }

  .grid-kpis {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 520px) {
  .grid-kpis {
    grid-template-columns: 1fr;
  }
}
</style>
